// Textos dos Destinatários de alerta do DP (02/11/2026), coletados por glob em
// core/i18n/messages.ts. O rótulo e a descrição de cada alerta vêm do catálogo do servidor,
// em português; aqui ficam os da tela.
export default {
  pt: {
    'dp.alertas.titulo': 'Destinatários de alerta',
    'dp.alertas.comoFunciona': 'Cada grupo é uma lista de e-mails que recebe os alertas marcados nele, sobre todos ou só sobre as pessoas, filiais e funções do recorte. O aviso de retorno sai uma vez por dia, o checklist da rescisão pelo botão Enviar pelo Hub do desligamento e os outros num resumo diário, sem repetir o que já saiu.',
    'dp.alertas.novo': 'Novo grupo',
    'dp.alertas.editar': 'Editar grupo',
    'dp.alertas.editarCurto': 'Editar',
    'dp.alertas.kpi.ativos': 'Grupos ativos',
    'dp.alertas.kpi.inativos': 'Inativos',
    'dp.alertas.kpi.emails': 'E-mails',
    'dp.alertas.kpi.cobertos': 'Alertas com grupo',
    'dp.alertas.kpi.deTotal': '{{com}} de {{total}}',
    'dp.alertas.semGrupo': 'Ninguém recebe',
    'dp.alertas.filtro.alerta': 'Alerta',
    'dp.alertas.filtro.todos': 'Todos os alertas',
    'dp.alertas.filtro.secao': '{{secao}}, todos',
    'dp.alertas.filtro.situacao': 'Situação',
    'dp.alertas.filtro.ativos': 'Ativos',
    'dp.alertas.filtro.inativos': 'Inativos',
    'dp.alertas.filtro.qualquer': 'Todos',
    'dp.alertas.buscar': 'Buscar grupo ou e-mail',
    'dp.alertas.col.grupo': 'Grupo',
    'dp.alertas.col.emails': 'E-mails',
    'dp.alertas.col.alertas': 'Alertas',
    'dp.alertas.col.quem': 'Sobre quem',
    'dp.alertas.ativo': 'Ativo',
    'dp.alertas.inativo': 'Inativo',
    'dp.alertas.ultimoEnvio': 'Último envio',
    'dp.alertas.nuncaEnviou': 'Nenhum envio',
    'dp.alertas.todos': 'Todos',
    'dp.alertas.recorte.pessoa': 'Pessoa',
    'dp.alertas.recorte.filial': 'Filial',
    'dp.alertas.recorte.funcao': 'Função',
    'dp.alertas.teste': 'Enviar teste',
    'dp.alertas.testeEnviado': 'Teste enviado a {{total}} endereços.',
    'dp.alertas.retirar': 'Retirar grupo',
    'dp.alertas.retirarConfirma': 'Retirar o grupo {{nome}}? Ele sai da tela e para de receber. A auditoria guarda o que ele tinha.',
    'dp.alertas.retirado': 'Grupo retirado.',
    'dp.alertas.salvo': 'Grupo salvo.',
    'dp.alertas.semResultado': 'Nenhum grupo com estes filtros.',
    'dp.alertas.form.nome': 'Nome do grupo',
    'dp.alertas.form.emails': 'E-mails',
    'dp.alertas.form.emailsAjuda': 'Digite e aperte Enter. Vírgula e ponto e vírgula também separam.',
    'dp.alertas.form.emailInvalido': 'Endereço inválido: {{email}}',
    'dp.alertas.form.ativo': 'Grupo ativo, recebe os alertas',
    'dp.alertas.form.alertas': 'Que alertas recebe',
    'dp.alertas.form.quem': 'Sobre quem recebe',
    'dp.alertas.form.todos': 'Todos',
    'dp.alertas.form.todosAjuda': 'Qualquer pessoa do DP',
    'dp.alertas.form.recorte': 'Só o recorte',
    'dp.alertas.form.recorteAjuda': 'Uma ou mais pessoas, filiais e funções. Basta uma delas para o grupo receber.',
    'dp.alertas.form.pessoas': 'Pessoas',
    'dp.alertas.form.filiais': 'Filiais',
    'dp.alertas.form.funcoes': 'Funções',
    'dp.alertas.form.ninguem': 'Ninguém com esse nome ou matrícula',
    'dp.alertas.form.observacao': 'Observação',
    'dp.alertas.form.semNome': 'Informe o nome do grupo.',
    'dp.alertas.form.semEmail': 'Informe ao menos um e-mail.',
    'dp.alertas.form.semAlerta': 'Escolha ao menos um alerta.',
    'dp.alertas.form.semRecorte': 'Escolha ao menos uma pessoa, filial ou função, ou marque Todos.',
    'dp.alertas.envio.diario': 'Uma vez por dia',
    'dp.alertas.envio.acao': 'Pelo botão do desligamento',
    'dp.alertas.envio.resumo': 'Resumo diário',
    'dp.alertas.irPara': 'Destinatários de alerta',
    'dp.alertas.linkRetorno': 'Quem recebe o aviso de retorno agora fica em Destinatários de alerta, por grupo, com recorte por pessoa, filial e função.',
    'dp.alertas.linkResumo': 'Os grupos, os alertas que cada um recebe e sobre quem ficam em Destinatários de alerta.',
  },
  en: {
    'dp.alertas.titulo': 'Alert recipients',
    'dp.alertas.comoFunciona': 'Each group is a list of e-mails that receives the alerts checked in it, about everyone or only about the people, branches and roles of its scope. The return notice goes out once a day, the termination checklist through the Send from the Hub button and the others in a daily summary, never repeating what was already sent.',
    'dp.alertas.novo': 'New group',
    'dp.alertas.editar': 'Edit group',
    'dp.alertas.editarCurto': 'Edit',
    'dp.alertas.kpi.ativos': 'Active groups',
    'dp.alertas.kpi.inativos': 'Inactive',
    'dp.alertas.kpi.emails': 'E-mails',
    'dp.alertas.kpi.cobertos': 'Alerts with a group',
    'dp.alertas.kpi.deTotal': '{{com}} of {{total}}',
    'dp.alertas.semGrupo': 'Nobody receives',
    'dp.alertas.filtro.alerta': 'Alert',
    'dp.alertas.filtro.todos': 'All alerts',
    'dp.alertas.filtro.secao': '{{secao}}, all',
    'dp.alertas.filtro.situacao': 'Status',
    'dp.alertas.filtro.ativos': 'Active',
    'dp.alertas.filtro.inativos': 'Inactive',
    'dp.alertas.filtro.qualquer': 'All',
    'dp.alertas.buscar': 'Search group or e-mail',
    'dp.alertas.col.grupo': 'Group',
    'dp.alertas.col.emails': 'E-mails',
    'dp.alertas.col.alertas': 'Alerts',
    'dp.alertas.col.quem': 'About whom',
    'dp.alertas.ativo': 'Active',
    'dp.alertas.inativo': 'Inactive',
    'dp.alertas.ultimoEnvio': 'Last sent',
    'dp.alertas.nuncaEnviou': 'Never sent',
    'dp.alertas.todos': 'Everyone',
    'dp.alertas.recorte.pessoa': 'Person',
    'dp.alertas.recorte.filial': 'Branch',
    'dp.alertas.recorte.funcao': 'Role',
    'dp.alertas.teste': 'Send test',
    'dp.alertas.testeEnviado': 'Test sent to {{total}} addresses.',
    'dp.alertas.retirar': 'Remove group',
    'dp.alertas.retirarConfirma': 'Remove the group {{nome}}? It leaves the screen and stops receiving. The audit trail keeps what it had.',
    'dp.alertas.retirado': 'Group removed.',
    'dp.alertas.salvo': 'Group saved.',
    'dp.alertas.semResultado': 'No group with these filters.',
    'dp.alertas.form.nome': 'Group name',
    'dp.alertas.form.emails': 'E-mails',
    'dp.alertas.form.emailsAjuda': 'Type and press Enter. Comma and semicolon also separate.',
    'dp.alertas.form.emailInvalido': 'Invalid address: {{email}}',
    'dp.alertas.form.ativo': 'Active group, receives the alerts',
    'dp.alertas.form.alertas': 'Which alerts it receives',
    'dp.alertas.form.quem': 'About whom it receives',
    'dp.alertas.form.todos': 'Everyone',
    'dp.alertas.form.todosAjuda': 'Any person in HR',
    'dp.alertas.form.recorte': 'Only the scope',
    'dp.alertas.form.recorteAjuda': 'One or more people, branches and roles. One of them is enough for the group to receive.',
    'dp.alertas.form.pessoas': 'People',
    'dp.alertas.form.filiais': 'Branches',
    'dp.alertas.form.funcoes': 'Roles',
    'dp.alertas.form.ninguem': 'Nobody with this name or ID',
    'dp.alertas.form.observacao': 'Note',
    'dp.alertas.form.semNome': 'Enter the group name.',
    'dp.alertas.form.semEmail': 'Enter at least one e-mail.',
    'dp.alertas.form.semAlerta': 'Choose at least one alert.',
    'dp.alertas.form.semRecorte': 'Choose at least one person, branch or role, or check Everyone.',
    'dp.alertas.envio.diario': 'Once a day',
    'dp.alertas.envio.acao': 'From the termination button',
    'dp.alertas.envio.resumo': 'Daily summary',
    'dp.alertas.irPara': 'Alert recipients',
    'dp.alertas.linkRetorno': 'Who receives the return notice is now set in Alert recipients, by group, scoped by person, branch and role.',
    'dp.alertas.linkResumo': 'The groups, the alerts each one receives and about whom are set in Alert recipients.',
  },
  es: {
    'dp.alertas.titulo': 'Destinatarios de alerta',
    'dp.alertas.comoFunciona': 'Cada grupo es una lista de correos que recibe las alertas marcadas en él, sobre todos o solo sobre las personas, sucursales y funciones del recorte. El aviso de regreso sale una vez al día, el checklist de la desvinculación por el botón Enviar por el Hub y las demás en un resumen diario, sin repetir lo que ya salió.',
    'dp.alertas.novo': 'Nuevo grupo',
    'dp.alertas.editar': 'Editar grupo',
    'dp.alertas.editarCurto': 'Editar',
    'dp.alertas.kpi.ativos': 'Grupos activos',
    'dp.alertas.kpi.inativos': 'Inactivos',
    'dp.alertas.kpi.emails': 'Correos',
    'dp.alertas.kpi.cobertos': 'Alertas con grupo',
    'dp.alertas.kpi.deTotal': '{{com}} de {{total}}',
    'dp.alertas.semGrupo': 'Nadie recibe',
    'dp.alertas.filtro.alerta': 'Alerta',
    'dp.alertas.filtro.todos': 'Todas las alertas',
    'dp.alertas.filtro.secao': '{{secao}}, todas',
    'dp.alertas.filtro.situacao': 'Situación',
    'dp.alertas.filtro.ativos': 'Activos',
    'dp.alertas.filtro.inativos': 'Inactivos',
    'dp.alertas.filtro.qualquer': 'Todos',
    'dp.alertas.buscar': 'Buscar grupo o correo',
    'dp.alertas.col.grupo': 'Grupo',
    'dp.alertas.col.emails': 'Correos',
    'dp.alertas.col.alertas': 'Alertas',
    'dp.alertas.col.quem': 'Sobre quién',
    'dp.alertas.ativo': 'Activo',
    'dp.alertas.inativo': 'Inactivo',
    'dp.alertas.ultimoEnvio': 'Último envío',
    'dp.alertas.nuncaEnviou': 'Ningún envío',
    'dp.alertas.todos': 'Todos',
    'dp.alertas.recorte.pessoa': 'Persona',
    'dp.alertas.recorte.filial': 'Sucursal',
    'dp.alertas.recorte.funcao': 'Función',
    'dp.alertas.teste': 'Enviar prueba',
    'dp.alertas.testeEnviado': 'Prueba enviada a {{total}} direcciones.',
    'dp.alertas.retirar': 'Retirar grupo',
    'dp.alertas.retirarConfirma': '¿Retirar el grupo {{nome}}? Sale de la pantalla y deja de recibir. La auditoría guarda lo que tenía.',
    'dp.alertas.retirado': 'Grupo retirado.',
    'dp.alertas.salvo': 'Grupo guardado.',
    'dp.alertas.semResultado': 'Ningún grupo con estos filtros.',
    'dp.alertas.form.nome': 'Nombre del grupo',
    'dp.alertas.form.emails': 'Correos',
    'dp.alertas.form.emailsAjuda': 'Escriba y presione Enter. Coma y punto y coma también separan.',
    'dp.alertas.form.emailInvalido': 'Dirección inválida: {{email}}',
    'dp.alertas.form.ativo': 'Grupo activo, recibe las alertas',
    'dp.alertas.form.alertas': 'Qué alertas recibe',
    'dp.alertas.form.quem': 'Sobre quién recibe',
    'dp.alertas.form.todos': 'Todos',
    'dp.alertas.form.todosAjuda': 'Cualquier persona de RR. HH.',
    'dp.alertas.form.recorte': 'Solo el recorte',
    'dp.alertas.form.recorteAjuda': 'Una o más personas, sucursales y funciones. Basta una de ellas para que el grupo reciba.',
    'dp.alertas.form.pessoas': 'Personas',
    'dp.alertas.form.filiais': 'Sucursales',
    'dp.alertas.form.funcoes': 'Funciones',
    'dp.alertas.form.ninguem': 'Nadie con ese nombre o matrícula',
    'dp.alertas.form.observacao': 'Observación',
    'dp.alertas.form.semNome': 'Indique el nombre del grupo.',
    'dp.alertas.form.semEmail': 'Indique al menos un correo.',
    'dp.alertas.form.semAlerta': 'Elija al menos una alerta.',
    'dp.alertas.form.semRecorte': 'Elija al menos una persona, sucursal o función, o marque Todos.',
    'dp.alertas.envio.diario': 'Una vez al día',
    'dp.alertas.envio.acao': 'Por el botón de la desvinculación',
    'dp.alertas.envio.resumo': 'Resumen diario',
    'dp.alertas.irPara': 'Destinatarios de alerta',
    'dp.alertas.linkRetorno': 'Quién recibe el aviso de regreso ahora está en Destinatarios de alerta, por grupo, con recorte por persona, sucursal y función.',
    'dp.alertas.linkResumo': 'Los grupos, las alertas que recibe cada uno y sobre quién están en Destinatarios de alerta.',
  },
}
